import { mergeClassNames } from '../../style';

type InternalParagraphProps = {
  children: React.ReactNode;
  size: 'mini' | 'miniPlus' | 'small' | 'smallPlus' | 'medium';
  className?: string;
  title?: string;
};

const InternalParagraph = ({ children, size, className: customClassName = '', title }: InternalParagraphProps) => {
  const headingStyle = mergeClassNames([
    { className: 'core-typography-paragraph-mini', include: ['mini', 'miniPlus'].includes(size) },
    { className: 'core-typography-paragraph-mini--plus', include: size === 'miniPlus' },
    { className: 'core-typography-paragraph-small', include: ['small', 'smallPlus'].includes(size) },
    { className: 'core-typography-paragraph-small--plus', include: size === 'smallPlus' },
    { className: 'core-typography-paragraph-medium', include: size === 'medium' },
    { className: customClassName },
  ]);

  return (
    <p className={headingStyle} title={title}>
      {children}
    </p>
  );
};

type ParagraphProps = Pick<InternalParagraphProps, 'children' | 'className' | 'title'>;
type ParagraphWithBoldProps = ParagraphProps & { bold?: boolean };

export const ParagraphMini = ({ children, bold = false, className, title }: ParagraphWithBoldProps) => (
  <InternalParagraph size={bold ? 'miniPlus' : 'mini'} className={className} title={title}>
    {children}
  </InternalParagraph>
);

export const ParagraphSmall = ({ children, bold = false, className, title }: ParagraphWithBoldProps) => (
  <InternalParagraph size={bold ? 'smallPlus' : 'small'} className={className} title={title}>
    {children}
  </InternalParagraph>
);

export const ParagraphMedium = ({ children, className, title }: ParagraphProps) => (
  <InternalParagraph size="medium" className={className} title={title}>
    {children}
  </InternalParagraph>
);
